/* eslint-disable react/jsx-no-undef */
import React, { Suspense } from "react";
import HeaderCarousel from "components/Homes/homeCarousel";
import SectionSkeleton from "./sectionskeleton";
import LazySection from "components/lazySection";
import HeaderSlider from "components/Homes/homeSlider";
const HomeAbout = React.lazy(() => import("components/Homes/homeAbout"));
const HomeServices = React.lazy(() => import("components/Homes/homeServices"));
const HomeProjects = React.lazy(() => import("components/Homes/homeProjects"));
const HomeCommunity = React.lazy(() => import("components/Homes/homeCommunity"));
const HomeSocialmedia = React.lazy(() => import("components/Homes/homeSocialmedia"));

const HomeNew: React.FC = () => {
 

 
  return (
    <>
      {/* Above the fold – load immediately */}
      {/* <HeaderCarousel /> */}
        <HeaderSlider /> 

      {/* Section-wise lazy loading */}
     <LazySection fallback={<SectionSkeleton height={300} />}>
        <HomeAbout />
      </LazySection> 

      <LazySection fallback={<SectionSkeleton height={350} />}>
        <HomeServices />
      </LazySection>
 
     

     <LazySection fallback={<SectionSkeleton height={300} />}>
        <HomeCommunity />
      </LazySection>
      
      <LazySection fallback={<SectionSkeleton height={350} />}>
        <HomeProjects />
      </LazySection>
        <LazySection fallback={<SectionSkeleton height={250} />}>
        <HomeSocialmedia />
      </LazySection> 
    </>
  );
};

export default HomeNew;
